module.exports = __webpack_public_path__ + "cot.jpg?dd7d2c0f144584b39f7be67054590dd8";